import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Button,
  Typography,
  LinearProgress,
  Slider,
  Chip,
  IconButton,
  Autocomplete,
  TextField,
  Modal,
  Card
} from '@mui/material';
import { useState } from 'react';
import DateTime from 'src/components/DateTime';
import FormActionButtons from 'src/components/FormActionButton';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import CustomButton from 'src/shared/customButtom';
import { DatePicker } from '@mui/lab';

function valuetext(value: number) {
  return `${value}°C`;
}

const minDistance = 1;

const BatchFilterPopOver = ({
  subjectData,
  gradeData,
  businessData,
  selectedBatchItems,
  handleDelete,
  handleAddBatchItem,
  batchGradeId,
  bathcSubjectId,
  setBatchGradeId,
  setBathcSubjectId,
  bnatchSetFormData,
  batchFormData,
  handleSave,
  handleClose,
  cityData,
  openRight,
  setSelectedBathcItems
}) => {
  const [experienceRange, setExperienceRange] = useState<number[]>([
    batchFormData.minExperience || 0,
    batchFormData.maxExperience || 0
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    bnatchSetFormData((prev) => ({
      ...prev,
      [name]: value
    }));

    if (name === 'bathcSubjectId') {
      setBathcSubjectId(value);
    } else if (name === 'batchGradeId') {
      setBatchGradeId(value);
    }
  };

  const handleReset = () => {
    bnatchSetFormData({
      city: '',
      businessId: '',
      subjectId: '',
      gradeId: '',
      createdOn: null,
      minExperience: 0,
      maxExperience: 0
    });
    setExperienceRange([0, 0]);
    setSelectedBathcItems([]);
  };
  const handleExperienceChange = (event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) return;

    const newExperience = [...experienceRange];
    if (activeThumb === 0) {
      newExperience[0] = Math.min(newValue[0], newExperience[1] - minDistance);
    } else {
      newExperience[1] = Math.max(newValue[1], newExperience[0] + minDistance);
    }
    setExperienceRange(newExperience);

    bnatchSetFormData((prev) => ({
      ...prev,
      minExperience: newExperience[0],
      maxExperience: newExperience[1]
    }));
  };

  return (
    <Modal
      open={openRight}
      onClose={handleClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'right',
        marginRight: '50px'
      }}
    >
      <Card
        sx={{
          maxHeight: '90vh',
          overflowY: 'auto',
          maxWidth: '800px'
        }}
      >
        <Box p={2} sx={{ width: '350px' }}>
          <Box mb={2}>
            <Grid
              container
              spacing={2}
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid item xs={12} md={12}>
                <Typography
                  sx={{
                    fontSize: { xs: '16px', md: '18px' },
                    fontWeight: 600,
                    lineHeight: '22px',
                    marginBottom: '2px',
                    color: '#01011A'
                  }}
                >
                  Batch Filter
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <DatePicker
                label="Select Date"
                views={['year', 'month', 'day']} // Show only year, month, and day
                onChange={(date) =>
                  handleChange({ target: { name: 'createdOn', value: date } })
                }
                value={batchFormData.createdOn || null}
                renderInput={(params) => <TextField fullWidth {...params} />}
              />
            </Grid>

            <Grid item xs={12} display="flex" alignItems="center">
              <Autocomplete
                id="city"
                fullWidth
                options={cityData as string[]}
                value={batchFormData.city || ''}
                autoHighlight
                disableClearable
                onChange={(event, newValue) => {
                  bnatchSetFormData((prevData) => ({
                    ...prevData,
                    city: newValue || ''
                  }));
                }}
                getOptionLabel={(option: string) => option}
                renderOption={(props, option: string) => (
                  <Box
                    component="li"
                    sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    {option}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="city"
                    label="Search and Select Location"
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'city'
                    }}
                    sx={{
                      '& .MuiInputLabel-root': {
                        color: '#01011A',
                        fontWeight: 600,
                        fontSize: '14px'
                      }
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} display="flex" alignItems="center">
              <FormControl fullWidth>
                <InputLabel
                  style={{
                    backgroundColor: 'white',
                    paddingLeft: '9px',
                    paddingRight: '9px',
                    color: '#01011A',
                    fontWeight: 600,
                    fontSize: '14px'
                  }}
                >
                  Select Organization
                </InputLabel>
                <Select
                  value={batchFormData.businessId}
                  onChange={handleChange}
                  name="businessId"
                >
                  {businessData?.data?.business?.map((business) => (
                    <MenuItem
                      key={business.businessId}
                      value={business.businessId}
                      sx={{ height: '50px' }}
                    >
                      {business.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} display="flex" alignItems="center">
              <FormControl fullWidth sx={{ marginRight: 1 }}>
                <InputLabel
                  style={{
                    backgroundColor: 'white',
                    paddingLeft: '9px',
                    paddingRight: '9px',
                    color: '#01011A',
                    fontWeight: 600,
                    fontSize: '14px'
                  }}
                >
                  Subject
                </InputLabel>
                <Select
                  value={bathcSubjectId}
                  onChange={(e) => setBathcSubjectId(e.target.value)}
                >
                  {subjectData?.data?.subject?.map((subject) => (
                    <MenuItem
                      key={subject.subjectId}
                      value={subject.subjectId}
                      sx={{ height: '50px' }}
                    >
                      {subject.caption}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth sx={{ marginRight: 1 }}>
                <InputLabel
                  style={{
                    backgroundColor: 'white',
                    paddingLeft: '9px',
                    paddingRight: '9px',
                    color: '#01011A',
                    fontWeight: 600,
                    fontSize: '14px'
                  }}
                >
                  Grade
                </InputLabel>
                <Select
                  value={batchGradeId}
                  onChange={(e) => setBatchGradeId(e.target.value)}
                >
                  {gradeData?.data?.grade?.map((grade) => (
                    <MenuItem key={grade.gradeId} value={grade.gradeId}>
                      {grade.caption}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Button
                variant="contained"
                color="primary"
                onClick={handleAddBatchItem}
              >
                Add
              </Button>
            </Grid>
            <Box
              mt={2}
              ml={2}
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1,
                maxWidth: '100%',
                overflow: 'hidden',
                maxHeight: '180px',
                overflowY: 'auto'
              }}
            >
              {selectedBatchItems?.map((item) => {
                const gradeCaption =
                  gradeData?.data?.grade.find(
                    (grade) => grade.gradeId === item.gradeId
                  )?.caption || 'Unknown Grade';
                const subjectCaption =
                  subjectData?.data?.subject.find(
                    (subject) => subject.subjectId === item.subjectId
                  )?.caption || 'Unknown Subject';
                return (
                  <Chip
                    key={`${item.subjectId}-${item.gradeId}`}
                    label={`${gradeCaption}-${subjectCaption}`}
                    onDelete={() => handleDelete(item)}
                    sx={{
                      marginRight: 1,
                      marginBottom: 1,
                      color: '#380563',
                      backgroundColor: '#3805631f',
                      whiteSpace: 'nowrap'
                    }}
                  />
                );
              })}
            </Box>
            <Grid item xs={12}>
              <Typography
                sx={{ color: '#01011A', fontWeight: 600, fontSize: '14px' }}
              >
                Year Of Experience
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  width: '100%',
                  mt: 2
                }}
              >
                <Slider
                  sx={{ width: '80%' }}
                  getAriaLabel={() => 'Minimum distance'}
                  value={experienceRange}
                  onChange={handleExperienceChange}
                  valueLabelDisplay="auto"
                  getAriaValueText={(value) => `${value} years`}
                  disableSwap
                  max={30}
                />
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '82%'
                  }}
                >
                  <Typography sx={{ fontSize: 14 }}>0 Yrs</Typography>
                  <Typography sx={{ fontSize: 14 }}>30 Yrs</Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
          <Grid item xs={12} p={2} mt={-2} mr={-2}>
            <Grid mt={2} item container justifyContent="flex-end" spacing={1}>
              <Grid item>
                <CustomButton
                  onClick={handleReset}
                  title="Reset"
                  type="cancel"
                />
              </Grid>
              <Grid item>
                <CustomButton onClick={handleSave} title="Apply" type="save" />
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Card>
    </Modal>
  );
};

export default BatchFilterPopOver;
